import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import {
  headerButtonsColor,
  headerIconSize,
  DropDownListButtonsColor,
} from 'utils/Global';
import {
  GetSaveDiscardButtonsParams,
  GetIngredientHeaderButtonsParams,
  GetExportButtonsListParams,
} from 'components/ingredients/IngredientConstants';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { IngredientTableRow } from 'business/models/Models';

export const getSaveDiscardButtons = (params: GetSaveDiscardButtonsParams) => {
  const { enableButtons, onSave, onDiscard } = params;
  const saveDiscardButtons: Array<RMCustomButtonProps> = [
    {
      iconProps: { name: 'Save', fill: '#24A148', ...headerIconSize },
      title: 'Save',
      isDisabled: !enableButtons,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: onSave,
    },
    {
      iconProps: { name: 'Discard', fill: '#DA1E28', ...headerIconSize },
      title: 'Discard',
      isDisabled: !enableButtons,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container',
      titleClass: 'header-button-title',
      onClick: onDiscard,
    },
  ];

  return saveDiscardButtons;
};

export const getIngredientHeaderButtons = (params: GetIngredientHeaderButtonsParams) => {
  const {
    isDisabled,
    modelRefCurrent,
    addIngredientType,
    addVendor,
    addLiquidClass,
    printLabels,
    exportsList,
    mergeIngredients,
    isMergeIngredientDisabled,
    isDeleteDisabled,
    showDeleteIngredientWarning,
    openIngredient,
    isOpenIngredientDisabled,
    createIngredient,
    addProteinType,
  } = params;

  const infoHeaderButtons: Array<RMCustomButtonProps> = [
    {
      iconProps: { name: 'AddLayer', fill: headerButtonsColor, ...headerIconSize },
      title: 'Create New Ingredient',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: createIngredient,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'AddIngredient', fill: headerButtonsColor, ...headerIconSize },
      title: 'Open',
      isDisabled: isOpenIngredientDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: openIngredient,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Delete', fill: headerButtonsColor, ...headerIconSize },
      title: 'Delete Ingredient',
      isDisabled: isDeleteDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: showDeleteIngredientWarning,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: {
        name: 'MergeIngredients',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Merge Ingredient',
      isDisabled: isMergeIngredientDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: mergeIngredients,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: {
        name: 'LiquidClassUnion',
        fill: headerButtonsColor,
        ...headerIconSize,
      },
      title: 'Liquid Class',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addLiquidClass,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'AddIngredient', fill: headerButtonsColor, ...headerIconSize },
      title: 'Ingredient Type',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addIngredientType,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'AddIngredient', fill: headerButtonsColor, ...headerIconSize },
      title: 'Protein Type',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addProteinType,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Vendor', fill: headerButtonsColor, ...headerIconSize },
      title: 'Vendor',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: addVendor,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'PrintBarcode', fill: headerButtonsColor, ...headerIconSize },
      title: 'Print Label',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: printLabels,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Import', fill: headerButtonsColor, ...headerIconSize },
      title: 'Import',
      isDisabled: isDisabled,
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: modelRefCurrent,
      mainContainerClass: 'justify-start',
    },
    {
      iconProps: { name: 'Export', fill: headerButtonsColor, ...headerIconSize },
      title: 'Export',
      isDisabled: isDisabled,
      dropDownList: exportsList,
      showChevronIcon: true,
      chevronIconInitialAngle: 315,
      chevronIconPosition: 'end',
      contentOrientation: 'Vertical',
      contentContainerClass: 'header-button-container-70 mt-3',
      titleClass: 'header-button-title text-center',
      onClick: () => {},
      mainContainerClass: 'justify-start',
    },
  ];
  return infoHeaderButtons;
};

export const useExportButtonsList = (params: GetExportButtonsListParams) => {
  const {
    exportIngredientsToExcel,
    exportIngredientsToText,
    exportIngredientsToDoc,
    exportIngredientsToXML,
    exportIngredientsToXMLSpreadsheet,
  } = params;

  const exportsList: IDropDownList[] = [
    {
      label: 'Excel File',
      iconProps: { name: 'ExcelFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToExcel,
      isDisabled: false,
    },
    {
      label: 'Word File',
      iconProps: { name: 'DocFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToDoc,
      isDisabled: false,
    },
    {
      label: 'Text File',
      iconProps: { name: 'TextFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToText,
      isDisabled: false,
    },
    {
      label: 'XML',
      iconProps: { name: 'XMLFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToXML,
      isDisabled: false,
    },
    {
      label: 'XML Spreadsheet',
      iconProps: { name: 'DocFile', fill: DropDownListButtonsColor },
      onClick: exportIngredientsToXMLSpreadsheet,
      isDisabled: false,
    },
  ];
  return exportsList;
};

export const isBufferStockConsistentAmongIngredients = (
  ingredients: IngredientTableRow[][],
) => {
  return (
    ingredients[0].some((item) => item.isBuffer == true) ===
    ingredients[1].some((item) => item.isBuffer == true)
  );
};

export const getTypedIngredientByIngredientId = (
  ingredientsData: IngredientTableRow[],
  ingredientsIds: number[],
): IngredientTableRow[][] => {
  return Object.values(
    ingredientsData.reduce((groupedRecords, record) => {
      const id = record.id;

      if (ingredientsIds.includes(id)) {
        if (!groupedRecords[id]) {
          groupedRecords[id] = [];
        }

        groupedRecords[id].push(record);
      }

      return groupedRecords;
    }, {}),
  );
};
